module.exports = __webpack_public_path__ + "img/table-7.39745a0a.jpg";